import React, { useState } from 'react';
import api from '../services/api';
import './MarquerFinJournee.css';

const MarquerFinJournee = ({ onSuccess, date = null }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleMarquerFin = async () => {
    if (!window.confirm('Confirmer la fin de votre journée de travail ?')) {
      return;
    }

    setLoading(true);
    setMessage('');
    setError('');

    try {
      const response = await api.pointage.marquerFin(date);
      setMessage(`Fin de journée enregistrée à ${response.heure_fin} ✅`);
      if (onSuccess) {
        setTimeout(() => onSuccess(response), 1500);
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Erreur lors de l\'enregistrement';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="marquer-fin-container">
      <button 
        onClick={handleMarquerFin} 
        disabled={loading}
        className="btn btn-warning btn-marquer-fin"
        title="Marquer votre heure de fin de journée"
      >
        {loading ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Enregistrement...
          </>
        ) : (
          <>
            <i className="bi bi-clock-fill me-2"></i>
            Marquer la fin
          </>
        )}
      </button>
      
      {message && (
        <div className="alert alert-success alert-dismissible fade show mt-2" role="alert">
          <i className="bi bi-check-circle-fill me-2"></i>
          {message}
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setMessage('')}
            aria-label="Close"
          ></button>
        </div>
      )}
      
      {error && (
        <div className="alert alert-warning alert-dismissible fade show mt-2" role="alert">
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          {error}
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setError('')}
            aria-label="Close"
          ></button>
        </div>
      )}
    </div>
  );
};

export default MarquerFinJournee;
